import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPopupParts: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.partNo !== undefined) {
			queryStr = objectToQuerystring({
				partNo: searchParams.partNo,
				currentPage,
				pageUnit
			});
		}

		return (
			client
				//sfaas-onsite-fe
				.get(`${BASE_URL}/comm/commpopup/partPopup/v1/parts` + queryStr)
				.then(response => (response && response.data) || null)
				.catch(error => {
					throw error.response.data;
				})
		);
	}
};
